/*
  COTANTIN VID 商品ページ（§3.3.2）。
  ギャラリーの並べ替え・絞り込みそのものは product-gallery.liquid（Prestige の filtered-indexes）が行う。
  ここでやるのは 3 つだけ：
  1. 帯の案内（「ストラップの質感を見る →」など）を押したら、同じ色の相手方の写真へ送る
  2. 色を切り替えたら、帯の中身（共通写真の色札）を新しい色に差し替える
  3. 色を切り替えたら、最初の写真（着用、なければ詳細）へ戻す
     （Prestige は variant の featured_media の position で送るが、並べ替えているので位置がずれる）
*/
(() => {
  if (window.__cotantinPdp) return;
  window.__cotantinPdp = true;

  const galleries = () => document.querySelectorAll('product-gallery.ct-gallery');

  document.addEventListener('click', (event) => {
    const hint = event.target.closest('.ct-gband__hint');
    if (!hint) return;
    event.preventDefault();
    event.stopPropagation();
    const gallery = hint.closest('product-gallery');
    const carousel = gallery?.carousel;
    const band = hint.closest('.ct-gband');
    if (!carousel || !band) return;
    const color = band.getAttribute('data-ct-color');
    const kind = hint.getAttribute('data-ct-goto');
    const index = carousel.cells.findIndex((cell) => {
      const b = cell.querySelector('.ct-gband');
      return b && b.getAttribute('data-ct-kind') === kind && b.getAttribute('data-ct-color') === color;
    });
    if (index >= 0) carousel.select(index);
  });

  const bind = (gallery) => {
    if (gallery.__ctBound) return;
    const form = document.forms[gallery.getAttribute('form')];
    if (!form) return;
    gallery.__ctBound = true;

    form.addEventListener('product:rerender', (event) => {
      const fragment = event.detail?.htmlFragment;
      if (!fragment) return;
      gallery.querySelectorAll('.product-gallery__media[data-media-id]').forEach((cell) => {
        const next = fragment.querySelector(`product-gallery[form="${gallery.getAttribute('form')}"] .product-gallery__media[data-media-id="${cell.getAttribute('data-media-id')}"] .ct-gband`);
        const current = cell.querySelector('.ct-gband');
        if (next && current) current.replaceWith(next.cloneNode(true));
      });

      // スマホのサムネイル（購入ブロック内の liquid ブロック）は描き直されて先頭が選択状態に戻るので、写真の位置に合わせ直す
      const selected = gallery.carousel?.selectedIndex ?? 0;
      document.querySelectorAll(`.ct-thumbs[aria-controls="${gallery.carousel?.id}"]`).forEach((nav) => {
        [...nav.querySelectorAll('button:not([hidden])')].forEach((button, index) => {
          button.setAttribute('aria-current', index === selected ? 'true' : 'false');
        });
      });
    });

    form.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      const previous = event.detail?.previousVariant;
      if (!variant || (previous && previous.option1 === variant.option1)) return;
      requestAnimationFrame(() => gallery.carousel?.select(0, { instant: true }));
    });
  };

  const init = () => galleries().forEach(bind);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
